var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useEffect, useState } from 'react';
import { ENTER_KEY, SPACE_KEY } from '../../../const/keyNames';
import { AccordionBodyWrapper, AccordionHeaderWrapper, AccordionInnerBodyWrapper, AccordionWrapper } from './subcomponents';
const ALLOWED_KEYS = [ENTER_KEY, SPACE_KEY];
const Accordion = (_a) => {
    var { header, body, expanded = false, transitionDuration, forceClose, forceRerenderBody, className, headerClickCallBack } = _a, props = __rest(_a, ["header", "body", "expanded", "transitionDuration", "forceClose", "forceRerenderBody", "className", "headerClickCallBack"]);
    const timeOutDuration = transitionDuration * 1000;
    const [transitionHasEnded, setTransitionHasEnded] = useState(expanded);
    const [isAccordionBodyShown, setIsAccordionBodyShown] = useState(expanded);
    const contentId = `${props.id}-accordion-content`;
    const onTransitionHasEnded = useCallback(() => {
        return setTimeout(() => {
            setTransitionHasEnded(isAccordionBodyShown);
        }, timeOutDuration);
    }, [isAccordionBodyShown, timeOutDuration]);
    const handleAccordionHeaderClick = useCallback(() => {
        setIsAccordionBodyShown((prevState) => !prevState);
        if (headerClickCallBack) {
            headerClickCallBack(!isAccordionBodyShown);
        }
    }, [isAccordionBodyShown, setIsAccordionBodyShown, headerClickCallBack]);
    const onForceCloseAccordionHandler = useCallback(() => {
        if (forceClose) {
            setIsAccordionBodyShown(false);
        }
    }, [forceClose, setIsAccordionBodyShown]);
    // Allows Accordion body to be re-rendered to refresh contents if needed
    const renderBody = useCallback(() => {
        if (transitionHasEnded || isAccordionBodyShown) {
            return _jsx(AccordionInnerBodyWrapper, { children: body });
        }
        return null;
    }, [transitionHasEnded, isAccordionBodyShown, body]);
    useEffect(() => {
        onForceCloseAccordionHandler();
        const transitionId = onTransitionHasEnded();
        return () => {
            clearTimeout(transitionId);
        };
    }, [forceClose, onForceCloseAccordionHandler, onTransitionHasEnded]);
    useEffect(() => {
        onTransitionHasEnded();
    }, [isAccordionBodyShown, onTransitionHasEnded]);
    return (_jsxs(AccordionWrapper, Object.assign({ className: className }, props, { children: [_jsx(AccordionHeaderWrapper, Object.assign({ role: "button", "aria-expanded": isAccordionBodyShown, "aria-controls": contentId, isAccordionBodyShown: isAccordionBodyShown, transitionDuration: transitionDuration, transitionHasEnded: transitionHasEnded, onClick: () => handleAccordionHeaderClick(), tabIndex: 0, onKeyDown: (event) => {
                    const { key } = event;
                    if (ALLOWED_KEYS.includes(key)) {
                        event.preventDefault();
                        handleAccordionHeaderClick();
                    }
                } }, { children: header })), _jsx(AccordionBodyWrapper, Object.assign({ isAccordionBodyShown: isAccordionBodyShown, transitionDuration: transitionDuration, transitionHasEnded: transitionHasEnded, id: contentId }, { children: forceRerenderBody ? (renderBody()) : (_jsx(AccordionInnerBodyWrapper, { children: body })) }))] })));
};
export default Accordion;
